export function validateUnsignedInteger(input) {
  return /^\d+$/.test(input);
}

export function validateDate(input) {
  return /^\d{4}\-\d{2}\-\d{2}$/.test(input);
}

export function validateEmail(input) {
  return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,6}$/i.test(input);
}

export function validatePhoneNumber(input) {
  return /\+?\d[\d() ]{8,}/.test(input);
}



// WEBPACK FOOTER //
// src/helpers/validation.js